// This file is auto-generated during build process
  // DO NOT EDIT MANUALLY - Changes will be overwritten
  import { Environment } from './environment.model';

  const HOST_URL = 'https://yss-admin-dev.lht.id.au';

  export const environment: Environment = {
    name: 'production',
    production: true,
    sentry_dsn: 'https://02315437d20835e63f9a9eeca23498eb@o4508515734650880.ingest.us.sentry.io/4511799014522880',
    hostURL: HOST_URL,
    apiURL: `${HOST_URL}/api/v1`,
    cmsApiURL: `${HOST_URL}/spina/api`,
    cmsToken: '4bmsrr65ah3oas5d4sd54st11k',
    GA: 'G-ZRCBY831J8',
    GTM: 'GTM-P6PX3V7N',
    googleSiteVerification: '',
  };

  export const PAGE_MAP = {
    'introduction-to-get-involved': 9,
  'introduction-to-get-referral': 10,
  'introduction-for-gps': 11,
  'about-the-program': 12,
  } as const;
  